import { API_URL } from "../config";

// Fonction utilitaire pour lire les cookies
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

const callApi = async (url, method, options = {}) => {
  const payload = { method, headers: { 'Content-Type': 'application/json' } };

  if (options.body)
    payload.body = JSON.stringify(options.body);

  if (options.token) {
    payload.headers.Authorization = `Bearer ${options.token}`;
  } else {
    const token = getCookie('stytch_session');

    if (token)
      payload.headers.Authorization = `Bearer ${token}`;
  }

  if (options.headers)
    payload.headers = { ...payload.headers, ...options.headers };

  try {
    const response = await fetch(`${API_URL}/${url}`, payload);

    if (options.raw)
      return response;

    if (!response.ok)
      throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();

    return data;
  } catch (error) {
    console.error(error, url, method);
    return null;
  }
};

export default callApi;